import { render } from "./POSPage.vue?vue&type=template&id=09712e78&scoped=true"
import script from "./POSPage.vue?vue&type=script&lang=js"
export * from "./POSPage.vue?vue&type=script&lang=js"

import "./POSPage.vue?vue&type=style&index=0&id=09712e78&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09712e78"]])

export default __exports__